import React, { useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { ChevronDown, Route } from "lucide-react";

export const LIFECYCLE_STAGES = [
  { value: "lead_ingest", label: "Lead Ingest", cls: "bg-slate-100 text-slate-700" },
  { value: "site_measure", label: "Site Measure", cls: "bg-sky-100 text-sky-700" },
  { value: "design", label: "Design Phase", cls: "bg-violet-100 text-violet-700" },
  { value: "contract_sent", label: "Contract Sent", cls: "bg-indigo-100 text-indigo-700" },
  { value: "fabrication", label: "Fabrication", cls: "bg-amber-100 text-amber-800" },
  { value: "installation", label: "Installation", cls: "bg-emerald-100 text-emerald-700" },
  { value: "completed", label: "Completed", cls: "bg-green-100 text-green-800" },
];

// Lifecycle stage pill with manual override (managers). Auto-advances from estimates/contracts/schedule/portal events.
export const LifecycleStagePill = ({ project, canEdit, onChanged }) => {
  const [open, setOpen] = useState(false);
  const stage = LIFECYCLE_STAGES.find(s => s.value === (project.lifecycle_stage || "lead_ingest")) || LIFECYCLE_STAGES[0];
  const idx = LIFECYCLE_STAGES.indexOf(stage);

  const setStage = async (value) => {
    setOpen(false);
    if (value === stage.value) return;
    try {
      await axios.put(`${API}/projects/${project.project_id}`, { lifecycle_stage: value });
      toast.success(`Stage set to ${LIFECYCLE_STAGES.find(s => s.value === value)?.label}`);
      onChanged?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to update stage"); }
  };

  return (
    <div className="relative inline-block" data-testid="lifecycle-stage-pill">
      <button type="button" disabled={!canEdit} onClick={() => setOpen(o => !o)}
        className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full ${stage.cls} ${canEdit ? "hover:ring-2 hover:ring-offset-1 hover:ring-indigo-200" : ""}`}
        title={project.lifecycle_source ? `Set by: ${project.lifecycle_source.replace(/[:_]/g, " ")}` : ""}>
        <Route className="w-3 h-3" /> {stage.label}
        <span className="opacity-60">· {idx + 1}/{LIFECYCLE_STAGES.length}</span>
        {canEdit && <ChevronDown className="w-3 h-3" />}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 mt-1 w-56 rounded-lg border bg-white shadow-xl py-1" data-testid="lifecycle-stage-menu">
            <p className="px-3 py-1.5 text-[10px] uppercase tracking-wide text-slate-400">Set job stage</p>
            {LIFECYCLE_STAGES.map((s, i) => (
              <button key={s.value} onClick={() => setStage(s.value)} data-testid={`lifecycle-option-${s.value}`}
                className={`w-full text-left px-3 py-1.5 text-sm flex items-center gap-2 hover:bg-slate-50 ${s.value === stage.value ? "font-semibold" : ""}`}>
                <span className={`w-5 h-5 rounded-full text-[10px] flex items-center justify-center ${i <= idx ? s.cls : "bg-slate-50 text-slate-400"}`}>{i + 1}</span>
                {s.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
